<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Categories</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Categories"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox
                            label="Active Only"
                            v-model="activeOnly"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn
                            color="success"
                            block
                            @click="editCategory({ Active: true })"
                        >
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="categories"
                            :loading="loading"
                            :search="search"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{props.item.DepartmentNames}}</td>
                                    <td>{{props.item.Name}}</td>
                                    <td>{{props.item.ProductTypeNames}}</td>
                                    <td>{{props.item.SortOrder}}</td>
                                    <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                    <td>
                                        <v-btn
                                            color="warning"
                                            block
                                            @click="editCategory(props.item)"
                                        >
                                            Edit
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark :disabled="saving" @click="cancelEditCategory">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title v-if="editedCategory && editedCategory.ID">Edit Category</v-toolbar-title>
                        <v-toolbar-title v-else>Add New Category</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-form ref="editForm" v-model="editCategoryValid">
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            :items="departments"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="editedCategory.Departments"
                                            label="Department"
                                            hint="Department"
                                            :rules="[rules.selectIDRequired]"
                                            multiple
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            counter="100"
                                            maxlength="100"
                                            v-model="editedCategory.Name"
                                            :rules="[rules.required]"
                                            label="Category Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            v-model="editedCategory.ProductTypes"
                                            :items="productTypes"
                                            label="Product Type"
                                            item-text="ProductTypeName"
                                            item-value="ID"
                                            :rules="[rules.selectIDRequired]"
                                            multiple>
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            maxlength="100"
                                            v-model="editedCategory.SortOrder"
                                            :rules="[rules.numeric]"
                                            label="Sort Order">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-checkbox label="Active" v-model="editedCategory.Active"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12 sm6>
                                        <v-btn block color="error" :disabled="saving" @click="cancelEditCategory">Cancel</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-btn block color="success" :disabled="!editCategoryValid" :loading="saving" @click="saveEditedCategory">Save</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <error-alert :content="saveError" :display="saveError"></error-alert>
                                    </v-flex>
                                </v-layout>                            
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import _ from "underscore";

export default {
    components: {
        ErrorAlert
    },
    props: [
        
    ],
    data() {
        return {
            rowsPerPage: [20, 50, 100],
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "SortOrder"
            },
            editedCategory: {},
            showEditDialog: false,
            editCategoryValid: false,
            search: "",
            activeOnly: true,
            rules: validationRules.rules,
            headers: [
                {
                    text: "Department",
                    value: "DepartmentName"
                },
                {
                    text: "Name",
                    value: "Name"
                },
                {
                    text: "Product Type",
                    value: "ProductTypeName"
                },
                {
                    text: "Sort Order",
                    value: "SortOrder"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    sortable: false
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.categoryStore.loading
                || this.$store.state.departmentStore.loading;
        },
        loadError() {
            return this.$store.state.categoryStore.loadError;
        },
        saving() {
            return this.$store.state.categoryStore.saving;
        },
        saveError() {
            return this.$store.state.categoryStore.saveError;
        },
        categories() {
            return this.$store.state.categoryStore.categories.filter(s => s.Active || !this.activeOnly);
        },
        departments(){
            return this.$store.state.departmentStore.departments.filter(d => d.Active);
        },
        productTypes(){
            return this.$store.state.productTypeStore.productTypes;
        }
    },
    methods: {
        loadCategories() {
            this.$store.dispatch("categoryStore/loadCategories");
        },
        loadDepartments() {
            this.$store.dispatch("departmentStore/loadDepartments");
        },
        loadProductTypes() {
            this.$store.dispatch("productTypeStore/loadProductTypes");
        },
        editCategory(item) {
            this.$store.dispatch("categoryStore/clearSaveError");

            // show which fields are mandatory when opening the edit form
            this.$refs.editForm.validate();

            this.editedCategory = Object.assign({}, item);

            // Simply the Departments list so that it can be saved/loaded
            delete this.editedCategory.DepartmentNames;
            delete this.editedCategory.ProductTypeNames;
            if (this.editedCategory.Departments){
                this.editedCategory.Departments = _.map(this.editedCategory.Departments, function(dept){
                    return dept.DepartmentID;
                });
            }
            if (this.editedCategory.ProductTypes){
                this.editedCategory.ProductTypes = _.map(this.editedCategory.ProductTypes, function(pt){
                    return pt.ProductTypeID;
                });
            }

            this.showEditDialog = true;
        },
        cancelEditCategory() {
            this.showEditDialog = false;
            this.editedCategory = {};
        },
        saveEditedCategory() {
            var that = this;

            let category = Object.assign({}, this.editedCategory);
            delete category.DepartmentNames;
            delete category.ProductTypeNames;

            this.$store.dispatch("categoryStore/saveCategory", {
                category: category,
                finally: function() {
                    if (that.$store.state.categoryStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditCategory();
                    }
                }
            });
        },
    },
    created() {
        this.loadCategories();
        this.loadDepartments();
        this.loadProductTypes();
    }
};
</script>

<style>
    
</style>
